module.exports = __webpack_public_path__ + "static/img/Connor-Watson.fea2f8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Connor-Watson.jpg
// module id = caoQ
// module chunks = 0